import React, { useState, useEffect, useRef } from 'react'
import { 
    Layout,
    Col, 
    Row,
    Image,
    Button,
    Space,
    Table,
} from 'antd';
import Navbar from '../../Components/Navbar/Navbar';
// import HeaderImage from '../../Assets/Images/CPM-HEADER-cropped-1.png'
import html2canvas from 'html2canvas';
import jsPDF from "jspdf";
// import TenantSignature from "../../Assets/Images/tenant_signature.png"
// import OwnerSignature from "../../Assets/Images/owner_signature.png"

import { useNavigate, useParams } from 'react-router-dom';
import { UseGetRequest } from '../../Utils/api/ApiRequests'
import { usePostRequest } from '../../hooks/usePostRequest'
import { useReactToPrint } from "react-to-print";
import { formatAmount, formatDate, capitalizeText, refreshPage, extractDateTime } from '../../Utils/Common';
import { 
    ProductOutlined,
} from '@ant-design/icons';
import { SeeAttachment } from '../../Components/SeeAttachment';
import { PreviewTable } from '../../Components/PreviewTable';

const PreviewPayment = () => {
    const navigate = useNavigate()
    const currentDate = new Date();
    const { id, type } = useParams();
    const [newAttachment, setNewAttachment] = useState([]);
    const [billingData, setBillingData] = useState([])
    const [reading, setReading] = useState([])
    const [isLoading, setIsLoading] = useState(false);
    const { callPost, loading } = usePostRequest(()=>{
        refreshPage()
    });
    
    const customSpinner = <ProductOutlined style={{ fontSize: 24 }} spin />;

    const handleSendEmail = async (ref) => {
        if (ref) {
            const element = document.getElementById(ref);
    
            html2canvas(element, { scale: 2 }).then(async (canvas) => {
                const scale = 0.7; // Set the desired scale (70%)
    
                // Create a new canvas with scaled dimensions
                const scaledCanvas = document.createElement('canvas');
                const context = scaledCanvas.getContext('2d');
                scaledCanvas.width = canvas.width * scale;
                scaledCanvas.height = canvas.height * scale;
    
                // Draw the original canvas onto the scaled canvas
                context.drawImage(canvas, 0, 0, canvas.width, canvas.height, 0, 0, scaledCanvas.width, scaledCanvas.height);
    
                // Convert the scaled canvas to an image
                const imgData = scaledCanvas.toDataURL('image/jpeg', 1);
    
                const pdf = new jsPDF();
                const pdfWidth = pdf.internal.pageSize.getWidth();
                const pdfHeight = pdf.internal.pageSize.getHeight();
                const imgWidth = scaledCanvas.width;
                const imgHeight = scaledCanvas.height;
    
                // Calculate the ratio needed to fit the image within the PDF dimensions
                const ratio = Math.min(pdfWidth / imgWidth, pdfHeight / imgHeight);
    
                // Calculate the new width and height of the image
                const newWidth = imgWidth * ratio;
                const newHeight = imgHeight * ratio;
    
                // Center the image in the PDF
                const imgX = (pdfWidth - newWidth) / 2;
                const imgY = 0;
    
                // Add the image to the PDF
                pdf.addImage(imgData, 'JPEG', imgX, imgY, newWidth, newHeight); // Use 'JPEG' format for better compression
                pdf.save(`${billingData?.trade_name}_Payment_${extractDateTime(currentDate)}.pdf`);
    
                // Convert the pdf file from Blob to File obj (needed for upload API)
                const blobPdf = pdf.output('blob');
                const formPdf = new File([blobPdf], `${billingData?.trade_name}_Payment_${extractDateTime(currentDate)}.pdf`, {
                    type: blobPdf.type,
                });
                
                let file = [];

                if(newAttachment){
                    file = newAttachment.map((data) => {
                        return data?.file_url
                    });
                }
    
                const finalValues = Object.entries({ payment_id: id, attachment: formPdf, additional_attachments: file, filename: `${billingData?.trade_name}_Payment_${extractDateTime(currentDate)}.pdf` }).map(([key, value]) => ({
                    key,
                    value,
                }));
    
                callPost('emails/send_payment', finalValues, true);
            });
        }
    };

    const columns = [
        {
            title: 'Billing No.',
            dataIndex: 'billing_id',
            key: 'billing_id',
            align: 'center'
        },
        // {
        //     title: 'Billing Details No.',
        //     dataIndex: 'id',
        //     key: 'id',
        //     align: 'center'
        // },
        {
            title: 'Description',
            dataIndex: 'description',
            key: 'description',
            align: 'center'
        },
        {
            title: 'Amount Due',
            dataIndex: 'balance',
            key: 'balance',
            align: 'right',
            render: (amount) => formatAmount(amount)
        },
        {
            title: 'Paid Amount',
            dataIndex: 'paid_amount',
            key: 'paid_amount',
            align: 'right',
            render: (amount) => formatAmount(amount)
        }
    ];

    const columns2 = [
        {
            title: 'Utility Charge',
            dataIndex: 'utility_type',
            key: 'utility_type',
            align: 'center'
        },
        {
            title: 'Period Covered',
            dataIndex: 'date_covered',
            key: 'date_covered',
            align: 'center'
        },
        {
            title: 'Previous Reading',
            dataIndex: 'previous_meter',
            key: 'previous_meter',
            align: 'center'
        },
        {
            title: 'Current Reading',
            dataIndex: 'current_meter',
            key: 'current_meter',
            align: 'center'
        },
        {
            title: 'Consumption',
            dataIndex: 'normal_consumption',
            key: 'normal_consumption',
            align: 'center'
        },
        {
            title: 'Rate',
            dataIndex: 'normal_rate',
            key: 'normal_rate',
            align: 'center'
        },
        {
            title: 'Amount Due',
            dataIndex: 'total_fee',
            key: 'total_fee',
            align: 'right',
            // render: (amount) => formatAmount(parseFloat(amount))
        }
    ];
    const columns3 = [
        {
          title: 'Date Added',
          dataIndex: 'added_on',
          key: 'added_on',
          width: '30%',
          render: (amount) => formatDate(amount),
        },
        {
          title: 'Attachments',
          dataIndex: 'link',
          key: 'link',
        },
    ];  

    const componentRef = useRef();
    const handlePrint = useReactToPrint({
        content: () => componentRef.current,
    });

    async function fetchBillingData  () {
        setIsLoading(true)
        const response = await UseGetRequest("payments/get_by_id", {payment_id: id});
        if (response?.data) {
            let attachment = response?.data?.data?.attachments?.map((file) => ({
            ...file,
            link: (
                <SeeAttachment
                attachments={[
                    { file_url: file.file_url, file_name: file.file_name },
                ]}
                />
            ),
            })) 
            setNewAttachment(attachment)
            const date = response?.data?.data?.utility_charge?.map((data) => ({
                billing_id: data.billing_id,
                previous_meter: data.previous_meter,
                current_meter: data.current_meter,
                total_consumption: data.total_consumption,
                normal_consumption: data.normal_consumption,
                total_fee: formatAmount(data.total_fee),
                utility_type: capitalizeText(data.utility_type),
                date_from: formatDate(data.date_from),
                date_to: formatDate(data.date_to),
                date_covered: formatDate(data.date_from) + " - " + formatDate(data.date_to),
                normal_rate: data.normal_rate,
            }))
          setBillingData(response?.data?.data);
          setReading(date)
        } else {
          setBillingData([])
        }
        setIsLoading(false);
    }
    useEffect(() => {
        fetchBillingData();
      // eslint-disable-next-line react-hooks/exhaustive-deps
      }, []);

    return (
        <Layout className='page'>
            <Navbar navKey={'property'}/>
            <Layout className='content-container content-container-print overflow-y'>
                <Row className='m-4 paper-view'>
                    <Col className='email-pad print-content' id="preview" ref={componentRef}>
                        <Row className='mb-5'>
                            <Col span={24} align="center">
                                <Image
                                    width='100%'
                                    height="90%"
                                    src={window.form_header}
                                    alt="login-image"
                                    preview={false}
                                />
                            </Col>
                        </Row>
                        <Row className='center mb-4'>
                            <Col className='divider-text'>
                                PAYMENT SLIP
                            </Col>
                        </Row>
                        <Row className='mb-2'>
                            <Col span={18} align="left">
                                <Space>
                                    <div className='text-sm'>
                                        {type === "owner" ? "Owner Name :" : "Tenant Name :"}
                                    </div>
                                    <div className='bold-text text-sm'>
                                        {billingData?.trade_name}
                                    </div>
                                </Space>
                            </Col>
                            <Col span={6} align="left">
                                <Space>
                                    <div className='text-sm'>
                                        Payment No.
                                    </div>
                                    <div className='bold-text text-sm'>
                                        {billingData?.id}
                                    </div>
                                </Space>
                            </Col>
                        </Row>
                        <Row className='mb-2'>
                            <Col span={18} align="left">
                                <Space>
                                    <div className='text-sm'>
                                        Property :
                                    </div>
                                    <div className='bold-text text-sm'>
                                        {billingData?.property_name}
                                    </div>
                                </Space>
                            </Col>
                            <Col span={6} align="left">
                                <Space>
                                    <div className='text-sm'>
                                        Unit Number.
                                    </div>
                                    <div className='bold-text text-sm'>
                                        {billingData?.rental_unit_name}
                                    </div>
                                </Space>
                            </Col>
                        </Row>
                        <Row className='mb-2'>
                            <Col span={18} align="left">
                                <Space>
                                    <div className='text-sm'>
                                        Business Address :
                                    </div>
                                    <div className='bold-text text-sm'>
                                        {billingData?.address}
                                    </div>
                                </Space>
                            </Col>
                            <Col span={6} align="left">
                                <Space>
                                    <div className='text-sm'>
                                        Date :
                                    </div>
                                    <div className='bold-text text-sm'>
                                        {formatDate(billingData?.payment_date)}
                                    </div>
                                </Space>
                            </Col>
                        </Row>
                       
                        <Row className='mb-2'>
                            {/* <Col span={18}>
                                <Space>
                                    <div>
                                        TIN :
                                    </div>
                                    <div className='bold-text'>
                                    {billingData?.tin}
                                    </div>
                                </Space>
                            </Col> */}
                            <Col span={18} align="left">
                                <Space>
                                    <div className='text-sm'>
                                        Payment Type :
                                    </div>
                                    <div className='bold-text text-sm'>
                                        {billingData?.payment_type}
                                    </div>
                                </Space>
                            </Col>
                        </Row>
                        {
                            billingData?.payment_type === "check" && (
                                <>
                                    <Row className='mb-2'>
                                        <Col span={18}>
                                            <Space>
                                                <div className='text-sm'>
                                                    Bank Name :
                                                </div>
                                                <div className='bold-text text-sm'>
                                                {billingData?.bank_name}
                                                </div>
                                            </Space>
                                        </Col>
                                        <Col span={6}align="left">
                                            <Space>
                                                <div className='text-sm'>
                                                    Check Number :
                                                </div>
                                                <div className='bold-text text-sm'>
                                                    {billingData?.check_number}
                                                </div>
                                            </Space>
                                        </Col>
                                    </Row>
                                    <Row className='mb-2'>
                                        <Col span={18}>
                                            <Space>
                                                <div className='text-sm'>
                                                    Check Date :
                                                </div>
                                                <div className='bold-text text-sm'>
                                                {formatDate(billingData?.check_date)}
                                                </div>
                                            </Space>
                                        </Col>
                                    </Row>
                                </>
                            )
                        }
                        {
                            billingData?.payment_type === "other" && (
                    
                                <Row className='mb-2'>
                                    <Col span={18}>
                                        <Space>
                                            <div className='text-sm'>
                                                Other Type :
                                            </div>
                                            <div className='bold-text text-sm'>
                                            {billingData?.other_type}
                                            </div>
                                        </Space>
                                    </Col>
                                    <Col span={6} align="left">
                                        <Space>
                                            <div className='text-sm'>
                                                Reference Number :
                                            </div>
                                            <div className='bold-text text-sm'>
                                                {billingData?.reference_no}
                                            </div>
                                        </Space>
                                    </Col>
                                </Row>
                            )
                        }
                        {
                            billingData.or_number && (
                                <Row className='mt-4'>
                                    <Col span={18} align="left">
                                        <Space>
                                            <div className='text-sm'>
                                                OR Number :
                                            </div>
                                            <div className='bold-text text-sm'>
                                                {billingData.or_number }
                                            </div>
                                        </Space>
                                    </Col>
                                    
                                </Row>
                            )
                        }
                        <Row gutter={[16, 16]} className=''>
                            <Col xs={24} sm={24} md={24} lg={24} xl={24} className='p-2 custom-table res-scroll'>
                                {/* <Table
                                    dataSource={billingData?.details}
                                    columns={columns}
                                    rowKey="id"
                                    pagination={false}
                                /> */}
                                <PreviewTable
                                    dataSource={billingData?.details}
                                    columns={columns}
                                />
                            </Col>
                        </Row>
                        {
                            type === "tenant" && (
                                <Row gutter={[16, 16]}>
                                    <Col xs={24} sm={24} md={24} lg={24} xl={24} className="p-2 res-scroll custom-table">
                                        {reading.length !== 0 && (
                                            // <Table
                                            //     dataSource={reading}
                                            //     columns={columns2}
                                            //     rowKey="id"
                                            //     pagination={false}
                                            // />
                                            <PreviewTable
                                                dataSource={reading}
                                                columns={columns2}
                                            />
                                        )}
                                    </Col>
                                </Row>
                            )
                        }
                        {
                            billingData?.remarks && (
                                <Row className='mb-2'>
                                    <Col span={18}>
                                        <Space>
                                            <div className='text-sm'>
                                                Remarks :
                                            </div>
                                            <div className='bold-text text-sm'>
                                                {billingData.remarks}
                                            </div>
                                        </Space>
                                    </Col>
                                    <Col span={6}>
                                        <Row>
                                            
                                        </Row>
                                    </Col>
                                </Row>
                            )
                        }
                        <Row gutter={[16, 16]}>
                            <Col span={12}>
                            
                            </Col>
                            <Col xs={24} sm={24} md={12} lg={12} xl={12} className='p-3 amount-total' align='right'>
                                Total: {formatAmount(billingData.grand_total)}
                            </Col>
                        </Row>
                        <Row gutter={[16, 16]}>
                            <Col span={24} className='p-2'>
                                {/* <Row>
                                    <Col>
                                        Please make checks payable to:
                                    </Col>
                                </Row>
                                <Row >
                                    <Col>
                                        BDO Unibank Account Number: 002420130444 (Amistad Property Management Services)
                                    </Col>
                                </Row>
                                <Row className='my-5'>
                                    <Col>
                                        Please advise if any payment made is not reflected in this statement.
                                    </Col>
                                </Row> */}
                               <Row className='my-4'>
                                    <Col align='left text-sm'>
                                        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start' }}>
                                            {/* {
                                                type === "owner" ? (
                                                    <img
                                                    src={OwnerSignature}
                                                    alt="Owner Signature"
                                                    style={{ height:'10vh', margin: '0' }}
                                                    />
                                                    ) : (
                                                        <img
                                                        src={TenantSignature}
                                                        alt="Tenant Signature"
                                                        style={{ height:'10vh', margin: '0' }}
                                                        />
                                                        )
                                                        } */}
                                            <div style={{ borderTop: '1px solid black', width: '150%', marginTop: '0', marginBottom: '0' }}></div>
                                            <div>Prepared By,</div>
                                        </div>
                                        {/* <Space direction='vertical' gutter={[0, 0]}>
                                            Prepared By,
                                            {
                                                type === "owner" ? (
                                                    <Image
                                                        src={OwnerSignature}
                                                        style={{height:'15vh', width: 'auto' }}
                                                        preview={false}
                                                    />
                                                ) : (
                                                    <Image
                                                        src={TenantSignature}
                                                        style={{height:'10vh', width: 'auto' }}
                                                        preview={false}
                                                    />
                                                )
                                            }
                                            __________________________
                                        </Space> */}
                                    </Col>
                                </Row>
                               <Row>
                                {
                                    type === "tenant" ? (
                                    
                                            <Col>
                                                <Row>{window.tenant_signatories}</Row>
                                                <Row>AMBRE Property Partners</Row>
                                            </Col>
                                    ) : (
                                            <Col>
                                                <Row className='text-sm'>{window.owner_signatories}</Row>
                                                <Row className='text-sm'>Billing and Collection</Row>
                                            </Col>
                                    )
                                }
                               </Row>
                            </Col>
                        </Row>
                    </Col>
                </Row>
                <Row className='btn-footer'>
                    <Space className='mb-4'>
                        <Button
                            onClick={type === "tenant" ? () => navigate('/tenant-payment') : () => navigate('/owner-payment')}
                            className='cancel-color btn-header mb-2'
                        >
                            Cancel
                        </Button>
                    
                        <Button
                             onClick={() => handleSendEmail('preview')}
                             className='secondary-btn mb-2 btn-header'
                             loading={loading}
                        >
                            Send to Email
                        </Button>
                    
                        <Button
                            onClick={handlePrint}
                            type='primary'
                            className='mb-2 btn-header'
                        >
                            Print
                        </Button>
                    </Space>
                </Row>
                <Row className='mx-4'>
                    <Col span={24}>
                        <Table 
                            columns={columns3} 
                            dataSource={newAttachment} 
                            pagination={false}
                            loading={{
                                indicator: customSpinner,
                                spinning: isLoading,
                            }}
                        />
                    </Col>
                </Row>
            </Layout>
        </Layout>
    )
}

export default PreviewPayment
